import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { NEVER, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { DoodMarketplaceModel } from '@core/models/marketplace.model';
import {
  buildMarketplaceLocaleContext,
  marketplaceLocaleRedirectUrl,
} from '@core/services/i18n/marketplace-locale-url';
import { MarketplaceService } from '@core/services/marketplace/marketplace.service';

export function ensureMarketplaceIsLoaded(): () => Observable<DoodMarketplaceModel> {
  return () => {
    const localizeRouterService = inject(LocalizeRouterService);
    const marketplaceService = inject(MarketplaceService);
    const settingsSelector = inject(SettingsStoreSelector);
    const platformId = inject(PLATFORM_ID);

    return localizeRouterService.hooks.initialized.pipe(
      switchMap(() => marketplaceService.loadMarketplace$()),
      switchMap(marketplace => {
        if (!isPlatformBrowser(platformId)) {
          return of(marketplace);
        }

        const nextUrl = marketplaceLocaleRedirectUrl(
          window.location.href,
          buildMarketplaceLocaleContext(marketplace, {
            currentStoreLocale: settingsSelector.app.locale,
            browserLang: navigator.language.split('-')[0],
          }),
        );
        if (!nextUrl) {
          return of(marketplace);
        }

        // The router would otherwise start the /it ↔ /it/from-qr loop before this
        // document unload finishes. Holding bootstrap keeps that navigation from starting.
        window.location.replace(nextUrl);
        return NEVER;
      }),
    );
  };
}
